function initWallpaperCalculator() {
  const calculator = document.getElementById('wallpaper-calculator');

  // Prevent initialization more than once
  if (!calculator || calculator.dataset.initialized === 'true') return;

  calculator.dataset.initialized = 'true';

  const calculateButton = calculator.querySelector('#calculate-rolls');
  const resultDisplay = calculator.querySelector('#roll-result');

  if (!calculateButton || !resultDisplay) return;

  // Available panel heights in feet
  const panelHeightsFeet = [2, 4, 6, 8, 10, 12, 14, 16, 18];

  calculateButton.addEventListener('click', () => {
    // 1. Get selected unit safely
    const unitInput = calculator.querySelector(
      'input[name="unit"]:checked'
    );

    const unit = unitInput ? unitInput.value : 'inches';

    // 2. Get wall dimensions
    const wallWidth = parseFloat(
      calculator.querySelector('#wall-width')?.value
    );

    const wallHeight = parseFloat(
      calculator.querySelector('#wall-height')?.value
    );

    // Validate wall width
    if (!wallWidth || wallWidth <= 0) {
      resultDisplay.textContent = 'Please enter a valid wall width.';
      return;
    }

    // Validate wall height
    if (!wallHeight || wallHeight <= 0) {
      resultDisplay.textContent = 'Please enter a valid wall height.';
      return;
    }

    // 3. Convert wall height to feet
    let wallHeightFeet;

    if (unit === 'inches') {
      wallHeightFeet = wallHeight / 12;
    } else if (unit === 'cm' || unit === 'centimeters') {
      wallHeightFeet = wallHeight / 30.48;
    } else {
      resultDisplay.textContent = 'Invalid unit selected.';
      return;
    }

    // 4. Find the appropriate panel height
    const matchedPanelHeight =
      panelHeightsFeet.find(height => wallHeightFeet <= height) ||
      panelHeightsFeet[panelHeightsFeet.length - 1];

    // 5. Panel width
    // 19 inches = 48.26 centimeters
    const panelWidth = unit === 'inches' ? 19 : 48.26;

    // 6. Calculate number of panels needed
    const panelsNeeded = Math.ceil(wallWidth / panelWidth);

    // 7. Display result
    resultDisplay.textContent =
      `You will need approximately ${panelsNeeded} ` +
      `panel${panelsNeeded === 1 ? '' : 's'} in ` +
      `${matchedPanelHeight} ft height.`;
  });
}

document.addEventListener(
  'DOMContentLoaded',
  initWallpaperCalculator
);

document.addEventListener(
  'shopify:section:load',
  initWallpaperCalculator
);

document.addEventListener(
  'shopify:block:select',
  initWallpaperCalculator
);